var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { brandColors } from '../../common/colors';
import { rotate } from '../../styled-components/animations';
export var LoadingContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\ttransition: width 0.3s ease;\n\twidth: ", ";\n"], ["\n\tposition: relative;\n\ttransition: width 0.3s ease;\n\twidth: ", ";\n"])), function (props) { return (props.loading ? '16px' : 0); });
export var Loader = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tborder: 3px solid\n\t\t", ";\n\tborder-radius: 50%;\n\tborder-top: 3px solid white;\n\twidth: 12px;\n\theight: 12px;\n\tanimation: ", " 1s ease infinite;\n\tposition: absolute;\n\ttop: -8px;\n\tleft: -8px;\n"], ["\n\tborder: 3px solid\n\t\t", ";\n\tborder-radius: 50%;\n\tborder-top: 3px solid white;\n\twidth: 12px;\n\theight: 12px;\n\tanimation: ", " 1s ease infinite;\n\tposition: absolute;\n\ttop: -8px;\n\tleft: -8px;\n"])), function (props) {
    if (props.disabled) {
        switch (props.$buttonType) {
            case 'primary':
                return brandColors.pinky[400];
        }
    }
    switch (props.$buttonType) {
        case 'primary':
            return brandColors.pinky[600];
        case 'secondary':
            return brandColors.giv[600];
        case 'texty':
            return brandColors.giv[500];
        default:
            return brandColors.giv[500];
    }
}, rotate);
var templateObject_1, templateObject_2;
